import { render, staticRenderFns } from "./EditFrame.vue?vue&type=template&id=4c9eadb7&scoped=true&"
import script from "./EditFrame.vue?vue&type=script&lang=ts&"
export * from "./EditFrame.vue?vue&type=script&lang=ts&"
import style0 from "./EditFrame.vue?vue&type=style&index=0&id=4c9eadb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9eadb7",
  null
  
)

export default component.exports